import React from 'react';
import { Grid } from '@mui/material';
import { ThreeCircles } from 'react-loader-spinner';

function Loader(props) {
    const { classNames, height,width } = props
    return (
        <Grid container >
            <Grid item xs={12} className= {classNames} >
                <ThreeCircles
                    height= {height}
                    width= {width}
                    color="#AE5DA5"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                    ariaLabel="three-circles-rotating"
                    outerCircleColor=""
                    innerCircleColor=""
                    middleCircleColor=""
                />
            </Grid>
        </Grid>
    );
}
Loader.defaultProps = {
    classNames : "flex-row-center height-70vh",
    height: '100',
    width: '100'
}
export default Loader;
